<template>
    <div class="search-wrapper">
        <input v-bind="props" v-model="searchInfo" type="text" @keypress="keyPressHandler" />
        <i class="i-search" @click="search"></i>
        <i class="i-s-del" @click="emptySearch" v-show="searchInfo != ''"></i>
    </div>
</template>

<script>
export default {
    name: "Search",
    props: ['value', 'widget', 'verifyInfo', 'validation'],
    data() {
        return {
            searchInfo: this.value || "",
        };
    },
    computed: {
        props() {
            return this.widget.props;
        }
    },
    methods: {
        emptySearch() {
            let searchInfo = this.searchInfo;
            if (searchInfo != "") {
                this.searchInfo = "";
                this.$emit('change', this.searchInfo);
            }
            return false;
        },
        search() {
            this.$emit('change', this.searchInfo);
        },
        keyPressHandler(event) {
            const isEnterKey = event.keyCode === 13;
            isEnterKey && this.search();
        }
    }
};
</script>

<style scoped lang="less">
.search-wrapper {
    padding: 6px 0 7px;
    position: relative;
    width: 320px;
    border-radius: 4px;
    border: 1px solid #d8e4f0;
    display: inline-flex;
    align-items: center;
    box-sizing: border-box;
}

.search-wrapper input {
    padding: 0px 40px 0px 7px;
    border: none;
    background: #fff;
    height: 100%;
    width: 100%;
    outline: none;
}

.i-search,
.i-s-del {
    position: absolute;
    display: inline-block;
    background: url("@{zhijiStaticImagePath}class-spr.png");
    top: 50%;
    margin-top: -9px;
    width: 18px;
    height: 18px;
    cursor: pointer;
}

.i-s-del {
    right: 35px;
    background-position: -4px -1px;
}

.i-search {
    right: 10px;
    vertical-align: middle;
    opacity: 0.7;
    background-position: -252px 0;
}

.i-search:hover {
    opacity: 1;
    background-position: -89px -113px;
}

.i-s-del:hover {
    background-position: -252px -20px;
}

// 加入选框使用的样式
.select-opt {
    box-sizing: border-box;
    width: 150px;
    margin: 0;
    border-bottom: none !important;
    border-top: none !important;
    border-left: none !important;
    border-radius: 0px !important;
    padding: 0px 8px !important;
    border-color: #d8e4f0 !important;
}

.select-opt:after {
    position: absolute;
    top: 5px !important;
    right: 10px !important;
    content: "";
    width: 6px;
    height: 10px;
    background-position: -127px -20px;
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg);
}

.select-active:after {
    transform: rotate(270deg);
    transition: transform 0.2s ease-in-out;
}
</style>
